<template>
  <section class="form-list">
    <el-form
      ref="form"
      :model="post"
      label-position="right"
      label-width="130px"
      class="form"
    >

      <div class="table-title table-title-top">课次券信息</div>

      <el-form-item label="课次券 ID">{{ post.card_ticket_id }}</el-form-item>

      <el-form-item label="所属学员">
        <v-avatar-nickname
          :value="post.selfie"
          :nickname="post.student_name"
          :is-center="false"
          :link-page-name="RouteConfig.studentDetail.name"
          :link-page-id="post.student_id"
        />
      </el-form-item>

      <el-form-item label="课次券类型">{{ post.card_ticket_type_name }}</el-form-item>

      <el-form-item label="有效天数">{{ post.expire_days | toYuan }} 天</el-form-item>

      <el-form-item label="失效时间">{{ post.expire_time | timeToYmdHis }}</el-form-item>

      <el-form-item label="剩余次数">
        <span class="success-color bolder">{{ post.expire_number | toYuan }}</span> 次
      </el-form-item>

      <el-form-item label="实际付款">
        <span class="danger-color bolder">{{ post.actual_payment | toYuan }}</span> 元
      </el-form-item>

      <el-form-item label="课次券修改记录">
        <span class="danger-color bolder">{{ post.update_record_count }}</span> 条
      </el-form-item>

      <el-form-item label="修改补差价总额">
        <span v-if="post.update_payment > 0" class="danger-color bolder">{{ post.update_payment | toYuan }}</span>
        <span v-else class="success-color bolder">{{ post.update_payment | toYuan }}</span>
        元
      </el-form-item>

      <el-form-item label="未消费金额">
        <span class="success-color bolder">{{ post.not_consumed_amount | toYuan }}</span> 元
      </el-form-item>

      <el-form-item label="购券门店">{{ post.card_ticket_store_name }}</el-form-item>


      <el-form-item label="购券时间">{{ post.card_ticket_add_time | timeToYmdHis }}</el-form-item>

      <div class="table-title">{{ post.request_administrator_id ? '申请' : '退券' }}信息</div>

      <template v-if="post.request_administrator_id">
        <el-form-item label="退券申请时间">{{ post.request_add_time | timeToYmdHi }}</el-form-item>

        <el-form-item v-if="post.request_administrator_id" label="退券申请者">
          <v-avatar-nickname
            :value="post.request_administrator_avatar"
            :nickname="post.request_administrator_nickname"
            :is-center="false"
          />
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="退券人">
          <v-avatar-nickname
            :value="post.review_administrator_avatar"
            :nickname="post.review_administrator_nickname"
            :is-center="false"
          />
        </el-form-item>
        <el-form-item label="退券时间">{{ post.add_time | timeToYmdHis }}</el-form-item>
      </template>

      <el-form-item label="退券门店">{{ post.store_name }}</el-form-item>

      <el-form-item label="退款金额" prop="del_payment">
        <span class="success-color bolder">{{ post.del_payment | toYuan }}</span> 元
      </el-form-item>

      <el-form-item label="是否录入错误">
        <span v-if="post.is_input_error" class="primary-color bolder">是</span>
        <span v-else class="danger-color bolder">否</span>
      </el-form-item>

      <el-form-item label="退券原因">
        <span class="bolder">{{ post.reason }}</span>
      </el-form-item>

      <el-form-item label="退券原因截图">
        <v-img v-if="post.reason_img" :value="post.reason_img"/>
        <template v-else>-</template>
      </el-form-item>

      <template v-if="post.request_administrator_id">
        <div class="table-title">审核信息</div>
        <el-form-item label="审核通过人">
          <v-avatar-nickname
            :value="post.review_administrator_avatar"
            :nickname="post.review_administrator_nickname"
            :is-center="false"
          />
        </el-form-item>
        <el-form-item label="审核通过时间">{{ post.add_time | timeToYmdHis }}</el-form-item>
      </template>

      <el-form-item>
        <el-button @click="RouteConfig.cardTicketDeletedList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { applyStates } from "@/enums/applyStates";
import { show } from "@/api/card-ticket-del-record";

export default {
  name: RouteConfig.cardTicketDeleteRecordDetail.name,
  data: () => ({
    RouteConfig,
    applyStates,
    isSaving: false,
    isPassing: false,
    isRejecting: false,
    isRevoking: false,
    isLoading: false,
    isLoadingError: false,
    post: {
      request_add_time: 0,
      card_ticket_add_time: 0,
      card_ticket_id: 0,
      add_time: 0,
      is_reviewing: 0,
      student_id: 0,
      selfie: '',
      student_name: '',
      card_ticket_type_name: '',
      expire_number: '',
      expire_days: '',
      expire_time: '',
      actual_payment: '',

      update_record_count: 0,
      update_payment: 0,

      not_consumed_amount: '',
      apply_state: applyStates.review.value,

      request_administrator_id: 0,
      request_administrator_avatar: '',
      request_administrator_nickname: '',

      review_administrator_id: 0,
      review_administrator_avatar: '',
      review_administrator_nickname: '',

      store_name: '',
      card_ticket_store_name: '',

      del_payment: 0,
      reason: '',
      reason_img: '',
      is_input_error: 0,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    async show() {
      this.isLoading = true;
      this.isLoadingError = false;
      const { isError, data } = await show(this.id);
      if (isError) {
        this.isLoading = false;
        this.isLoadingError = true;
        return;
      }

      const { post } = this;
      const updateCardInfo = {};
      Object.keys(data).forEach(key => {
        if (key in post) updateCardInfo[key] = data[key];
      });
      Object.assign(post, updateCardInfo);
      this.isLoading = false;
    },
  },
};
</script>
<style src="../student/update-request-detail.css" scoped/>
